import React from "react";

const TextareaField = ({ value, onChange, placeholder, rows, required }) => {
  return (
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder || ""}
      rows={rows || 4}
      required={required}
      className="textarea-field"
    />
  );
};

export default TextareaField;
